import { Formdata as Data, getFormdataStatusText } from '@/typings/api/Formdata'
import { dateFormatter } from '@/helpers/dateFormatter'
import { USERS_ROUTES } from '@/views/Users/utils'
import { PUBLICATIONS_ROUTES } from '@/views/Publications/utils'
import { VIEW } from '@/helpers/enums/table-actions'
import { TPL_DOWNLOAD, TPL_DOWNLOAD_EMPTY, TPL_UPLOAD } from '@/views/FormData/table-actions'

export const TABLE_ACTIONS_ADMIN = Object.freeze([
  TPL_DOWNLOAD_EMPTY,
  TPL_DOWNLOAD,
  {
    ...VIEW,
    tooltip: 'Список ревизий',
  },
])

export const TABLE_ACTIONS = Object.freeze([
  TPL_DOWNLOAD_EMPTY,
  TPL_DOWNLOAD,
  TPL_UPLOAD,
  {
    ...VIEW,
    tooltip: 'Список ревизий',
  },
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'ID',
    value: 'id',
    sortable: false,
    width: '60px',
  },
  {
    text: 'Логин',
    value: 'user.username',
    width: '100px',
    sortable: false,
    getRoute: (data: Record<string, unknown>): Record<string, unknown> => ({
      name: USERS_ROUTES.VIEW,
      params: {
        id: data.user_id,
      },
    }),
  },
  {
    text: 'Пользователь',
    value: 'user.full_name',
    sortable: false,
    cellClass: 'BTablePublicationFormdata__user',
  },
  {
    text: '',
    value: 'status_icon',
    sortable: false,
    width: '20px',
  },
  {
    text: 'Статус',
    value: 'status',
    sortable: true,
    width: 130,
    field: getFormdataStatusText,
  },
  {
    text: 'Проект сбора данных',
    value: 'data_collection.name',
    sortable: false,
    getRoute: (data: Record<string, unknown>): Record<string, unknown> => ({
      name: PUBLICATIONS_ROUTES.VIEW,
      params: {
        // @ts-ignore object-types
        id: data.data_collection.publication_id,
      },
    }),
  },
  {
    text: 'Дата создания',
    value: 'created_at',
    sortable: false,
    width: 144,
    field: (value: Data['created_at']) => (
      value && dateFormatter(value)
    ),
  },
  {
    text: 'Дата подачи',
    value: 'publish_date',
    sortable: true,
    width: 144,
    field: (value: Data['updated_at']) => (
      (value && dateFormatter(value)) || '-'
    ),
  },
])
